/** Google Maps JavaScript API key (Places Autocomplete). */
export const GOOGLE_MAPS_API_KEY = 'AIzaSyC3mPJFAM-J9WUIN4km3GzYqprHBaBVwKI';

export const GOOGLE_MAPS_LANGUAGE = 'en';
export const GOOGLE_MAPS_REGION = 'au';

/** Script URL for Maps JS API with Places library. */
export function googleMapsScriptUrl(region?: string): string {
  const regionCode = (region ?? GOOGLE_MAPS_REGION).trim().toLowerCase() || GOOGLE_MAPS_REGION;
  return (
    `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}` +
    `&libraries=places&language=${GOOGLE_MAPS_LANGUAGE}&region=${encodeURIComponent(regionCode)}`
  );
}

export const GOOGLE_MAPS_SCRIPT_URL = googleMapsScriptUrl();
